module.exports = __webpack_public_path__ + "876abca0ea708d9cd62ceade7f4420f3.jpg";